const Webdata = () => import('@/pages/webdata/Search.vue');

export default [
  {
    path: '/webdata/search',
    name: 'webdata',
    component: Webdata,
  },
]